<template>
  <a-modal :open="open" @cancel="closeForm">
  <h2>Сброс пароля</h2>
    <a-divider style="margin: 16px 0" />

    <div class="reset-password-form">
      <p>Выберите вариант сброса</p>
      <a-radio-group class="password-radio-group" v-model:value="passwordResetForm.type">
        <a-radio :value="'auto'">Сгенерировать автоматически</a-radio>
        <a-radio :value="'manual'">
          Ввести вручную
        </a-radio>
      </a-radio-group>

      <div class="password-field">
        <a-input v-model:value="passwordResetForm.password" v-if="passwordResetForm.type === 'manual'" :status="statusError.password ? 'error' : ''"/>
        <span v-if="statusError.password">
          Пароль должен содержать минимум 8 символов
        </span>
      </div>

      <a-checkbox v-model:checked="passwordResetForm.reset_required">Обязательная смена пароля</a-checkbox>
    </div>
    <template #footer>
      <a-divider />
      <div class="action-buttons">
        <a-row justify="end" :gutter="8">
          <a-col>
            <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
          </a-col>
          <a-col>
            <a-button class="primary-button" :loading="modalActionLoading" @click="handlePasswordReset">Сбросить</a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {reactive, ref} from "@vue/runtime-core";

export default {
  props: {
    open: Boolean,
    currentActionUser: Object,
    selectedUsers: Array,
    type: String,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);

    const passwordResetForm = reactive({
      type: 'auto',
      password: '',
      reset_required: false,
    });

    const statusError = reactive({
      password: false,
    })

    const handlePasswordReset = () => {
      statusError.password = false;

      if (passwordResetForm.type === 'manual' && passwordResetForm.password.length < 8) {
        statusError.password = true;
        modalActionLoading.value = false;
        return;
      }

      modalActionLoading.value = true;

      let users = [];
      if (props.currentActionUser?.id) {
        users.push(props.currentActionUser?.id);
      } else {
        users = props.selectedUsers;
      }

      store.dispatch('users/resetStaffPassword', {...passwordResetForm, users: users}).then(() => {
        message.success('Пароль сброшен');
        context.emit('submitted')
      }).finally(() => {
        modalActionLoading.value = false;
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    return {
      passwordResetForm,
      modalActionLoading,
      closeForm,
      handlePasswordReset,
      statusError
    }
  }
}
</script>

<style scoped lang="scss">
.reset-password-form {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.password-radio-group {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

:deep(.ant-divider-horizontal) {
  margin: 16px 0 !important;
}
</style>